import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { Service } from 'src/app/services';

@Component({
  selector: 'app-iptv-confirmation',
  templateUrl: './iptv-confirmation.component.html',
  styleUrls: ['./iptv-confirmation.component.sass']
})
export class IptvConfirmationComponent implements OnInit {
  public screenView: boolean = false;
  public screen: number = Number(sessionStorage.getItem("PlanSelectionScreen"));
  public tabActive = 'Mis Equipos y Servicios';
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public session: number;
  public content: object;
  public token: string = sessionStorage.getItem("token");
  public idPlan: string = sessionStorage.getItem("idPlan");
  public dataBuyProcces: any;
  public dataPlan: any;
  public dataSVA: any[] = [];
  public nameOffer: string = '';
  public nameOfferShort: string = '';
  public listSva: string = "";
  public amountSva: number = 0;
  public totalAmount: number = 0;
  public itemsCart: any;
  public itemsOrder: any;
  public hasSva: any = [];
  public nameSva: string = '';
  public nameSvaShort: string = '';
  public nameDevice: string = '';
  public numberOfDevices: number = 0;
  public nameStreaming: string = '';
  public hasContract: boolean = false;
  public contractMonths: number;
  public installments: number = 0;
  public typeCard: string = '';
  public priceMonth: number = 0;
  public amountStreaming: number = 0;
  constructor(private active: ActivatedRoute, public AngularFireAnalytics: AngularFireAnalytics, public global: GlobalService, private router: Router, private loadingScreenService: LoadingScreenService, private services: Service) {
    this.AngularFireAnalytics.setCurrentScreen("Netflix");
    this.AngularFireAnalytics.logEvent("Netflix-Screenview");
  }
  ngOnInit() {
    this.global.tokenShop=sessionStorage.getItem("tokenShop");
    this.dataLoading();
  }
  dataLoading() {
    this.loadingScreenService.startLoading();
    this.services.proccessOrderIptv(this.token, this.global.tokenShop).subscribe((data: any) => {
      this.loadingScreenService.stopLoading();
      this.itemsOrder = data;
      this.itemsCart = data.cartInfo;
      if (this.itemsCart.products.length > 0) {
        this.totalAmount = this.itemsCart.totalPrice;
        this.loadDataPlan(this.itemsCart.products);
      }
    });
  }
  loadDataPlan(data: any) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].plan) {
        this.dataPlan = data[i];
      }
    }
    this.loadProducts();
    this.loadStreaming();
    sessionStorage.setItem("tokenShop",null);
    sessionStorage.removeItem("tokenShop");
    this.listSva = this.listSva.substr(0, 20) + " ...";
    this.screenView = true;
  }
  loadProducts() {
    let swDevice = 0;
    let swOffer = 0;
    this.hasContract = this.itemsCart.bitContract;
    this.contractMonths = this.itemsCart.intContractMonths;
    this.paymentMethod();
    for (let i = 0; i < this.itemsCart.products.length; i++) {
      if (this.itemsCart.products[i].plan == true) {
        if (this.itemsCart.products[i].offers.length > 0) {
          for (let j = 0; j < this.itemsCart.products[i].offers.length; j++) {
            if (swOffer > 0) {
              this.nameOffer += ' / ';
            }
            this.nameOffer += '  ' + this.global.stringCalculation(this.itemsCart.products[i].offers[j].productName, 1, this.global.maximumString);
            swOffer++;
          }
        }
      }
      if (this.itemsCart.products[i].plan == false && this.itemsCart.products[i].equipment == false) {
        this.hasSva = true;
        if (swDevice > 0) {
          this.nameSva += ' / ';
        }
        this.nameSva += '  ' + this.global.stringCalculation(this.itemsCart.products[i].productName, 1, this.global.maximumString);
        this.amountSva += this.itemsCart.products[i].decPrice;
        swDevice++;
      }
      if (this.itemsCart.products[i].equipment == true) {
        this.nameStreaming = this.itemsCart.products[i].productName;
        this.numberOfDevices += this.itemsCart.products[i].qty;
        this.installments = this.itemsCart.products[i].installments;
      }
    }
    this.nameOfferShort = this.global.textShortener(this.nameOffer, "", 26, "...");
    this.nameSvaShort = this.global.textShortener(this.nameSva, "", 26, "...");
  }
  paymentMethod() {
    this.typeCard = this.itemsOrder.paymentInfo.cardType;
    switch (this.typeCard) {
      case 'V':
        this.typeCard = 'Visa';
        break;
      case 'M':
        this.typeCard = 'Master';
        break;
      case 'X':
        this.typeCard = 'American';
        break;
    }
  }
  goToHome() {
    this.router.navigate(['home']);
  }
  print() {
    window.print();
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  changeTab(idSession) {
    this.global.validateSession();
    this.session = idSession;
  }

  loadStreaming() {
    let sum = 0;
    let qty = 0;
    let installments = 0;
    let hasEdit: boolean = false;
    for (let i = 0; i < this.itemsCart.products.length; i++) {
      if (this.itemsCart.products[i].equipment == true) {
        sum += this.itemsCart.products[i].decPrice;
        qty += this.itemsCart.products[i].qty;
        installments = this.itemsCart.products[i].installments;
        hasEdit = true;
      }
    }
    if (this.hasContract == true) {
      if (this.contractMonths == 24) {
        if (this.numberOfDevices == 1) {
          this.amountStreaming = sum;
        }
        if (this.numberOfDevices > 1) {
          this.amountStreaming = (sum / installments);
        }
      }
      if (this.contractMonths == 12) {
        if (this.numberOfDevices == 1) {
          this.amountStreaming = sum;
        }
        if (this.numberOfDevices > 1) {
          this.amountStreaming = (sum / installments);
        }
      }
    }
    else {
      this.amountStreaming = sum;
    }
  }
}
